(ns app.front.view.admin.migration.copy-committee-templates-to-domain
  (:require [app.front.view.admin.migration.template :as admin-migration-template]
            [core.front.event :refer [>evt]]))

(defn view [match]
  [admin-migration-template/admin-page-for-migration
   {:task-id   :app.admin.migration.task/copy-committee-templates-to-domain
    :title     "Copy committee templates to domain-level meeting agenda templates"
    :help-text (str "This migration copies existing committee agenda templates to domain-level "
                    "meeting agenda templates with naming format 'Municipality - Permit - Committee Name'. "
                    "Only committees with customized templates will be copied. "
                    "Requires the domain-level-meetings feature flag to be enabled.")}
   match])

(def route
  {:name        :view/admin.migration.copy-committee-templates-to-domain
   :view        view
   :controllers [{:start (fn [_]
                           (>evt [::admin-migration-template/fetch-migration-tasks
                                  :app.admin.migration.task/copy-committee-templates-to-domain]))}]})
